import { getSupabaseClient } from "@/services/supabase/client";
import { BannerPlacement, PortalBanner } from "@/services/supabase/types";

type GetActiveBannersOptions = {
  placements?: BannerPlacement[];
};

export const getActiveBanners = async ({
  placements,
}: GetActiveBannersOptions = {}) => {
  const supabase = getSupabaseClient();

  let query = supabase
    .from("kp_banners_active_v1")
    .select("*")
    .order("created_at", { ascending: false });

  if (placements?.length) {
    query = query.in("placement", placements);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data ?? []) as PortalBanner[];
};

export const getBannerText = (
  banner: PortalBanner,
  language: string | undefined,
) => {
  if (language === "de") {
    return banner.text_de ?? banner.text_en ?? banner.text_fr;
  }

  if (language === "fr") {
    return banner.text_fr ?? banner.text_en ?? banner.text_de;
  }

  return banner.text_en ?? banner.text_de ?? banner.text_fr;
};

export const getBannerCta = (
  banner: PortalBanner,
  language: string | undefined,
) => {
  if (!banner.cta_enabled) {
    return null;
  }

  if (language === "de") {
    return {
      label: banner.cta_de_label ?? banner.cta_en_label ?? banner.cta_fr_label,
      link: banner.cta_de_link ?? banner.cta_en_link ?? banner.cta_fr_link,
    };
  }

  if (language === "fr") {
    return {
      label: banner.cta_fr_label ?? banner.cta_en_label ?? banner.cta_de_label,
      link: banner.cta_fr_link ?? banner.cta_en_link ?? banner.cta_de_link,
    };
  }

  return {
    label: banner.cta_en_label ?? banner.cta_de_label ?? banner.cta_fr_label,
    link: banner.cta_en_link ?? banner.cta_de_link ?? banner.cta_fr_link,
  };
};
